<form [formGroup]="form">
  <div class="form-row">
    <label for="txtTitle">{{ "TITLE" | translate | requiredLabel }}</label>
    <input
      type="text"
      id="txtTitle"
      class="w-full"
      pInputText
      formControlName="title"
      maxlength="255"
    />
  </div>

  <div class="form-row">
    <label for="txtAllowedProfiles">{{ "Perfiles Permitidos"  | requiredLabel }}</label>
    <app-profile-select formControlName="allowedProfiles"></app-profile-select>
  </div>
</form>

<div class="p-dialog-footer">
  <p-button
    label="Guardar cambios"
    (click)="saveChanges()"
    [loading]="saving"
  ></p-button>
</div>
